import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-type"]
const _hoisted_2 = {
  key: 0,
  class: "form",
  "data-type": "modal"
}
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "abstract" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "control" }
const _hoisted_10 = {
  class: "label",
  for: "NameSurname"
}
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "control" }
const _hoisted_13 = {
  class: "label",
  for: "Phone"
}
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "control" }
const _hoisted_16 = {
  class: "label",
  for: "Email"
}
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { class: "control" }
const _hoisted_19 = {
  class: "label",
  for: "Company"
}
const _hoisted_20 = {
  class: "item",
  "data-lable": "top"
}
const _hoisted_21 = { class: "control" }
const _hoisted_22 = {
  class: "label",
  for: ""
}
const _hoisted_23 = {
  class: "fieldset",
  "data-width": "50%"
}
const _hoisted_24 = { class: "item" }
const _hoisted_25 = { class: "checkbox" }
const _hoisted_26 = { for: "isPrivacyPolicy" }
const _hoisted_27 = ["href"]
const _hoisted_28 = {
  class: "fieldset",
  "data-width": "50%"
}
const _hoisted_29 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_30 = {
  class: "form-items",
  "data-type": "buttons"
}
const _hoisted_31 = {
  class: "item calltoaction",
  "data-size": "big"
}
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "lable" }
const _hoisted_34 = { class: "item" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = {
  key: 1,
  class: "success-box"
}
const _hoisted_37 = { class: "page-content" }
const _hoisted_38 = { class: "title" }
const _hoisted_39 = {
  class: "abstract mrg",
  "data-mrgb": "30"
}
const _hoisted_40 = {
  class: "calltoaction mrg",
  "data-mrgt": "20"
}

import { ref, onMounted, nextTick } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import ResponsiveHelper from "@Scripts/Infrastructure/ResponsiveHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoRequest',
  props: {
    recaptchaSiteKey: {},
    isDialog: {},
    infoType: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);

onMounted(() => {
    ResponsiveHelper.onResize();
});

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoading.value = true;

    formData.value.originPage = window.location.href;

    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: 'Submit' });

        try {
            await Axios.post(routes.Support_InfoRequest, formData.value, { headers: { "RecaptchaVerificationToken": token } });

            isSuccess.value = true;

            GTagHelper.sendEvent("form_submit", "info_request");
        } catch (error: any) {
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }

        isLoading.value = false;
    });
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

function closeDialog() {
    if ((<any>parent).$.fancybox.getInstance()) {
        nextTick(() => {
            (<any>parent).$.fancybox.getInstance().close(false);
        });
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "info-request",
    "data-type": __props.infoType
  }, [
    (!isSuccess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(localizer).get("Coupon.Common.Coupon_Title")), 1),
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(localizer).get("Coupon.Common.Coupon_Abstract")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("fieldset", {
              class: "fieldset",
              "data-width": "50%",
              disabled: isLoading.value
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(localizer).get("Coupon.Common.NameSurname")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "NameSurname",
                    name: "NameSurname",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.nameSurname) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': isValidationError('NameSurname') }, 'textbox'])
                  }, null, 2), [
                    [
                      _vModelText,
                      formData.value.nameSurname,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(localizer).get("Coupon.Common.Phone")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    id: "Phone",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.phone) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': isValidationError('Phone') }, 'textbox'])
                  }, null, 2), [
                    [
                      _vModelText,
                      formData.value.phone,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(localizer).get("Coupon.Common.Email")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "Email",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.email) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': isValidationError('Email') }, 'textbox'])
                  }, null, 2), [
                    [
                      _vModelText,
                      formData.value.email,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(localizer).get("Coupon.Common.Company")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "Company",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.company) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': isValidationError('Company') }, 'textbox'])
                  }, null, 2), [
                    [
                      _vModelText,
                      formData.value.company,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(localizer).get("Coupon.Common.Message")), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    type: "text",
                    id: "Message",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.message) = $event)),
                    rows: "3",
                    cols: "15",
                    class: _normalizeClass([{ 'input-validation-error': isValidationError('Message') }, 'textarea'])
                  }, null, 2), [
                    [
                      _vModelText,
                      formData.value.message,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ])
              ])
            ], 8, _hoisted_7),
            _createElementVNode("fieldset", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "isPrivacyPolicy",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.isPrivacyPolicy) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, formData.value.isPrivacyPolicy]
                  ]),
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(localizer).get("Coupon.Common.PrivacyDisclaimer_Text")), 1),
                  _cache[8] || (_cache[8] = _createTextVNode()),
                  _createElementVNode("a", {
                    class: "link",
                    href: _unref(routes).Terms_PrivacyPolicy,
                    target: "_blank"
                  }, _toDisplayString(_unref(localizer).get("Coupon.Common.PrivacyDisclaimer_Button")), 9, _hoisted_27)
                ])
              ])
            ]),
            _createElementVNode("fieldset", _hoisted_28, [
              (validationErrors.value.length !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (submitForm())),
                    class: "button",
                    disabled: isLoading.value
                  }, [
                    _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(localizer).get("Coupon.Common.Send")), 1)
                  ], 8, _hoisted_32)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", {
                  class: "captcha-terms",
                  innerHTML: _unref(localizer).get('App.Recaptcha.CaptchaTerms')
                }, null, 8, _hoisted_35)
              ])
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("img", {
              src: "/images/info-request-big.png",
              width: "629",
              height: "700",
              alt: "Technical Ceramic",
              class: "image",
              loading: "lazy"
            }, null, -1))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(localizer).get("Coupon.Common.Success_Title")), 1),
            _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(localizer).get("Coupon.Common.Success_Text")), 1),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", {
                class: "button",
                "data-color": "green",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (closeDialog()))
              }, _toDisplayString(_unref(localizer).get("Coupon.Common.ContinueNavigation")), 1)
            ])
          ])
        ]))
  ], 8, _hoisted_1))
}
}

})